import { Link } from 'react-router-dom';
import { useMigas } from '../lib/migas';
import { Contenedor } from '../componentes/Contenedor';
import { Brujula } from '../componentes/iconos';

/**
 * Marcador de posición para las secciones que el menú ya declara y que todavía
 * no están construidas.
 *
 * Existe para que no redirijan al inicio en silencio: un clic que no lleva a
 * ninguna parte se lee como una aplicación rota, no como una sección pendiente.
 */
export function EnConstruccion({ titulo, detalle }: { titulo: string; detalle: string }) {
  useMigas([{ texto: titulo }]);

  return (
    <Contenedor ancho="texto">
      <div className="rounded-2xl border border-marino-100 bg-white px-8 py-16 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-marino-50 text-marino-300">
          <Brujula size={26} />
        </div>
        <h1 className="text-xl font-bold text-marino-800">{titulo}</h1>
        <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-marino-500">{detalle}</p>
        <p className="mt-6 text-xs text-marino-400">
          Esta sección todavía no está construida. Aparece en el menú porque ya está definida
          en el alcance.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block text-sm font-medium text-marino-600 hover:text-naranja-600"
        >
          Volver al inicio
        </Link>
      </div>
    </Contenedor>
  );
}
